import React from 'react';
import { Richtext } from 'storyblok-js-client';
import { Props } from '../types';
import { filterProps, slottedToComponents } from '../helpers';
import { Link } from '../../services/navigation/types';

type Author = {
  name: string;
  url: string;
  identifier: string;
}

type Category = {
  name: string;
  url: string;
  identifier: string;
}

export type TeaserFields = {
  teaser_url: Link | string;
  headline: string;
  layout: string;
  size: string;
  teaser_type: string;
  hide_teaser_type: boolean;
  subtitle?: string;
  description?: Richtext;
  date?: string;
  slotted_media;
  slotted_link;
  categories?: Array<Category>;
  authors?: Array<Author>;
}

type TeaserProps = Props<TeaserFields> & {
  className?: string;
}

export const Teaser = ({
  blok, getComponent, slot, className,
}: TeaserProps): JSX.Element => {
  const { props, slotted } = filterProps(blok);

  const teaserUrl = props['teaser-url']?.startsWith('http') ? props['teaser-url'] : `/${props['teaser-url']}`.replace('//', '/');
  props['teaser-url'] = teaserUrl;
  // the code checks if the value of teaserUrl is equal to /.
  // If it is, the teaser-url property is removed from the props object.
  if (teaserUrl === '/') {
    delete props['teaser-url'];
  }

  const allProps = {
    ...props,
    ...(slot ? { slot } : {}),
    // eslint-disable-next-line no-underscore-dangle
    ...(blok._uid ? { uid: blok._uid } : {}),
    // eslint-disable-next-line no-underscore-dangle
    ...((blok.id || blok._uid) ? { id: blok.id || blok._uid } : {}),
  };

  const children = slottedToComponents(getComponent, slotted);

  return (
    <roche-teaser class={className} {...allProps}>{children}</roche-teaser>
  );
};
